// PRO-563. The "Product recommendation" section of a GPT action. The engine mirrors these defaults in
// product-recommendation.prompt.js — an action saved before this section existed carries no
// `productRecommendation` key at all, and both sides have to read that as the same thing.
export const PRODUCT_RECOMMENDATION_DEFAULTS = Object.freeze({
  enabled: false,
  relevantInformation: '',
  showContinue: false,
  // On, because the assistant has always offered quick replies — the toggle can only ever take them away.
  quickFilters: true,
  layout: ''
})

export const PRODUCT_RECOMMENDATION_FIELDS = Object.freeze({
  RELEVANT_INFORMATION: {
    label: 'Relevant information',
    lengthLimit: 1000,
    placeholder: 'the intended task, budget, size, frequency of use, compatibility requirements',
    tooltip: `
      <b>Relevant information</b> lists the preferences worth asking about for your catalog. For example:
      <i class="block">
        the intended task, material being worked on, hobby or professional use, budget, size
      </i>
      It is added to the answer as: "Depending on the request, relevant information may include
      &lt;your list&gt; or other preferences."
    `
  },
  QUICK_FILTERS: {
    label: 'Offer quick filters',
    tooltip: 'Experimental. Lets the assistant offer tappable suggestions ("adidas", "up to 500 EUR") ' +
      'next to its replies. On by default; turning it off makes it ask in plain text instead.'
  },
  SHOW_CONTINUE: {
    label: 'Offer a "more products" button',
    tooltip: 'Adds a button under the products that loads the next ones from the knowledge base, ' +
      'leaving out what the customer has already been shown.'
  },
  LAYOUT: {
    label: 'Recommendation display',
    tooltip: 'How product cards are presented. <b>Automatic</b> picks per answer: one product as a hero, ' +
      'a photo-led grid when the customer asks what something looks like, rows otherwise.'
  }
})

// '' = the engine's own per-answer heuristics (product-layout.js), which is what every bot does today.
export const PRODUCT_LAYOUT_OPTIONS = Object.freeze([
  { value: '', text: 'Automatic' },
  { value: 'carousel', text: 'Carousel' },
  { value: 'rows', text: 'Rows' },
  { value: 'grid', text: 'Grid' },
  { value: 'hero', text: 'Hero' }
])
